import moment from "moment-timezone";
import {getDriverCount, getLoads, getActivityListByPage } from '@/api/dashboard'
import { systemInfo } from '@/shared-services'

// const endTime = moment().hour(23).minutes(59).seconds(59).format('YYYY-MM-DD HH:mm:ss')
// const startTime = moment().hour(0).minutes(0).seconds(0).subtract(14, 'days').format('YYYY-MM-DD HH:mm:ss')
const state = {
    namespaced: true,
    state: {
        loadList: [],
        loadLoading: false,
        loadSearchParams: {},
        activeLoads: 0,
        inProgress: 0,
        assigned: 0,
        toBeAssigned: 0,
        driverList: {},
        driverLoading: false,
        driverSearchParams: {},
        activitList: {},
        activitLoading: false,
        activitSearchParams: {},
        activitDialogList: [],
        activitDialogLoading: false,
        activitDialogSearchParams: {
            size: 20,
            search: null,
            page: 1,
            after: '',
            before: ''
        },
        activityTotal: 0,
        loadTime: '',
        activitPageTotal: 0
    },
    mutations:{
        SET_LOAD_LIST(state, data) {
            state.activeLoads = data.activeLoads || 0
            state.assigned = data.assignedLoads || 0
            state.inProgress = data.inTransitLoads || 0
            state.toBeAssigned = data.toBeAssignedLoads || 0
            state.loadList = data.loadsList || []
        },
        SET_LOAD_LOADING(state, truthy) {
            state.loadLoading = truthy
        },
        SET_LOAD_SEARCH_PARAMS(state, data) {
            state.loadSearchParams = data
        },

        SET_DRIVER_LIST(state, list) {
            state.driverList = list || {}
        },
        SET_DRIVER_LOADING(state, truthy) {
            state.driverLoading = truthy
        },
        SET_DRIVER_SEARCH_PARAMS(state, data) {
            state.driverSearchParams = data
        },
        CLEAR_ACTIVIT_LIST(state) {
            state.activitList = []
        },
        SET_ACTIVIT_LIST_TOTAL(state, data) {
            state.activitPageTotal = data
        },
        SET_ACTIVIT_LIST(state, list) {
            state.activitList = state.activitList.concat(list)
        },
        SET_ACTIVIT_LOADING(state, truthy) {
            state.activitLoading = truthy
        },
        SET_ACTIVIT_SEARCH_PARAMS(state, data) {
            state.activitSearchParams = data
        },

        SET_ACTIVIT_DIALOG_LIST(state, data) {
            state.activitDialogList = data.data || []
            state.activityTotal = data.total || 0
        },
        SET_ACTIVIT_DIALOG_LOADING(state, truthy) {
            state.activitDialogLoading = truthy
        },
        SET_ACTIVIT_DIALOG_SEARCH_PARAMS(state, data) {
            state.activitDialogSearchParams = data
        },
        SET_LOAD_TIME(state, data) {
            state.loadTime = data
        },
    },
    actions: {
        getDriver({ commit}, data) {
           return getDriverCount(data).then(res => {
                let data = res?.res?.data || {}
                commit('SET_DRIVER_LIST', data.data)
            }, () => {
                commit('SET_DRIVER_LIST', {})
            })
        },
        getLoadsList({ commit }, data) {
            commit('SET_LOAD_TIME', moment.tz(Date.now(), moment.tz.guess()).format('MMM DD, YYYY, HH:mm z'))
            commit('SET_LOAD_LOADING', true)
           return getLoads(data).then(res => {
                console.log(res)
                let data = res?.res?.data || {}
                commit('SET_LOAD_LIST', data.data)
            }, () => {
                commit('SET_LOAD_LIST', {})
            }).finally(() => {
                commit('SET_LOAD_LOADING', false)
            })
        },
        getActivityLIst({ commit }, params = {}) {
            // let params = JSON.parse(JSON.stringify(state.activitSearchParams))
            // params.page > 0 ? params.page-- : ''
            if (params.page == 0) commit('CLEAR_ACTIVIT_LIST')
            if (params.isPageReload) commit('SET_ACTIVIT_LOADING', true)
            delete params.isPageReload
          return getActivityListByPage(params).then(res => {
                let data = res?.res?.data || {}
                console.log(data.data.data)
                data.data.data.forEach(item => {
                    if (!systemInfo.isCommand && item.type == 1) {
                        item.flag = false
                    }
                    if(item.action.includes('uploaded')) {
                        let arr = item.action.trim().split(' ')
                        item.actionFile1 = arr.splice(0, 2).join(' ')
                        item.actionFile2 = arr.splice(0, arr.length - 2).join(' ')
                        item.actionFile3 = arr.join(' ')
                        item.frontType = 'file'
                        // item.frontFileType = a1.join(' ')
                        // console.log(a1)
                        console.log(arr, '3333')
                    }
                });
                commit('SET_ACTIVIT_LIST', data.data.data)
                commit('SET_ACTIVIT_LIST_TOTAL', data.data.total)
            }, () => {
                commit('SET_ACTIVIT_LIST', [])
            }).finally(() => {
                console.log(99999999)
                commit('SET_ACTIVIT_LOADING', false)
            })
        },
        setSearchParams({ commit, state }, data) {
            if (data) {
                const field = data.name
                const obj = Object.assign({}, state.activitDialogSearchParams)
                obj[field] = data.value
                commit('SET_ACTIVIT_DIALOG_SEARCH_PARAMS', obj)
            }
        },
        getActivityDialogList({ commit, state }, companyId) {
            let params = JSON.parse(JSON.stringify(state.activitDialogSearchParams))
            params.page > 0 ? params.page -- : ''
            if (companyId) {
                params.companyId = companyId
            }
            if (params.search === '') {
                params.search = null
            }
            commit('SET_ACTIVIT_DIALOG_LOADING', true)
            getActivityListByPage(params).then(res => {
                if (res) {
                    let data = res?.res?.data || {}
                    data.data && data.data.data && data.data.data.forEach(item => {
                        if (!systemInfo.isCommand && item.type == 1) {
                            item.flag = false
                        }
                        if(item.action.includes('uploaded')) {
                            let arr = item.action.trim().split(' ')
                            item.actionFile1 = arr.splice(0, 2).join(' ')
                            item.actionFile2 = arr.splice(0, arr.length - 2).join(' ')
                            item.actionFile3 = arr.join(' ')
                            item.frontType = 'file'
                            // item.frontFileType = a1.join(' ')
                            // console.log(a1)
                            // console.log(arr, '3333')
                        }
                    })
                    console.log(data, '00000')
                    commit('SET_ACTIVIT_DIALOG_LIST', data.data)
                }
            }, () => {
                commit('SET_ACTIVIT_DIALOG_LIST')
            }).finally(() => {
                commit('SET_ACTIVIT_DIALOG_LOADING', false)
            })
        }
    },
    getters: {
        loadList: state => state.loadList,
        loadLoading: state => state.loadLoading,
        loadSearchParams: state => state.loadSearchParams,
        driverList: state => state.driverList,
        driverLoading: state => state.driverLoading,
        driverSearchParams: state => state.driverSearchParams,
        activitList: state => state.activitList,
        activitLoading: state => state.activitLoading,
        activitSearchParams: state => state.activitSearchParams,
        activitDialogList: state => state.activitDialogList,
        activitDialogLoading: state => state.activitDialogLoading,
        activitDialogSearchParams: state => state.activitDialogSearchParams,
        activityTotal: state => state.activityTotal,
        activeLoads: state => state.activeLoads,
        inProgress: state => state.inProgress,
        assigned: state => state.assigned,
        toBeAssigned: state => state.toBeAssigned,
        loadTime: state => state.loadTime,
        activitPageTotal: state => state.activitPageTotal,
    }
}

export default state